// extracted by mini-css-extract-plugin
export var root = "Accordion-module--root--Gc8nV";